import React from "react";
import { EmptyState } from "./Primitives";
import { BarList } from "./DataBars";
import { pct } from "../utils/format";
import { useMoney } from "../utils/currency";
import { withRemainder } from "../utils/derive";

/**
 * Stake mix — one component, used by both Casino DNA (§4.4) and Sports DNA
 * (§4.5.3) so the two sections stay directly comparable.
 *
 * The payload's percentages sum to 92 in the sample, so an "Other" remainder is
 * appended rather than rescaling the five known buckets up to 100 (§2.2).
 */
export function StakeMix({ stakes, colorClass = "bg-primary" }) {
  const { moneyExact } = useMoney();

  if (!stakes || !stakes.length) {
    return <EmptyState minHeight={132} message="No stake pattern yet — this builds once the player has bet a few times." />;
  }

  const rows = withRemainder(
    [...stakes]
      .sort((a, b) => (b.pct || 0) - (a.pct || 0))
      .map((stake) => ({ label: moneyExact(stake.amount_kes), pct: stake.pct })),
    "label"
  ).map((row) => ({
    label: row.label,
    value: row.pct,
    display: pct(row.pct),
    muted: row.isRemainder,
    tip: row.isRemainder
      ? `Other stake sizes · ${pct(row.pct)} of bets`
      : `${row.label} · ${pct(row.pct)} of bets`,
  }));

  // Wider label column than the design's KES mock: "USDT 0.0015" is a longer
  // string than "KES 10", and crypto brands are where this tab is live first.
  return <BarList rows={rows} max={100} colorClass={colorClass} labelWidth={84} valueWidth={40} />;
}
